import { VueRegistration } from "@abaco/web-common/src/app";
const CONTEXT = "STANDARD_PORTAL";

const globals: VueRegistration = {
    CRPriceItemListContainer: () => import("./components/tiles/priceItem/PriceItemListContainer.vue"),
    CRPriceItemList: () => import("./components/tiles/priceItem/PriceItemList.vue"),
    CRPriceItemDetail: () => import("./components/tiles/priceItem/PriceItemDetail.vue"),

    CRPriceAdd: () => import("./components/tiles/price/PriceAdd.vue"),

    // PUBLIC CHARTS
    PlotPricesChartTile: {
        meta: {
            i18nDescrKey: "plot-prices",
            filters: ["farm-select-nav-bar-item", "campaign-select-nav-bar-item", "plot-selection-nav-bar-item"],
            pinnable: true,
            tag: CONTEXT,
        },
        component: () => import("./components/tiles/charts/PlotPricesChartTile.vue"),
    },
    PlotGroupPricesChartTile: {
        meta: {
            i18nDescrKey: "plot-group-prices",
            filters: [
                "farm-select-nav-bar-item",
                "campaign-select-nav-bar-item",
                "plot-selection-nav-bar-item",
                "plot-group-selection-nav-bar-item",
            ],
            pinnable: true,
            tag: CONTEXT,
        },
        component: () => import("./components/tiles/charts/PlotGroupPricesChartTile.vue"),
    },
    ActivityPricesChartTile: {
        meta: {
            i18nDescrKey: "activity-prices",
            filters: ["farm-select-nav-bar-item", "campaign-select-nav-bar-item", "plot-selection-nav-bar-item"],
            pinnable: true,
            tag: CONTEXT,
        },
        component: () => import("./components/tiles/charts/ActivityPricesChartTile.vue"),
    },

    CompaniesComparisonSupplyChainChartsTile: {
        meta: {
            i18nDescrKey: "company-comparison-sc",
            filters: ["s-c-leader-select-nav-bar-item", "campaign-select-nav-bar-item"],
            pinnable: true,
            tag: CONTEXT,
        },
        component: () => import("./components/tiles/charts/companyComparison/supplyChainTile.vue"),
    },

    CropPricesDetailChartTile: {
        meta: {
            i18nDescrKey: "crop-prices",
            filters: ["farm-select-nav-bar-item", "campaign-select-nav-bar-item", "plot-selection-nav-bar-item"],
            pinnable: true,
            tag: CONTEXT,
        },
        component: () => import("./components/tiles/charts/CropPricesDetailChartTile.vue"),
    },
    TotalCostsTile: {
        meta: {
            i18nDescrKey: "total-costs",
            filters: [
                "farm-select-nav-bar-item",
                "campaign-select-nav-bar-item",
                "plot-selection-nav-bar-item",
                "block-selection-nav-bar-item",
            ],
            pinnable: true,
            tag: CONTEXT,
        },
        component: () => import("./components/tiles/charts/TotalCostsTile.vue"),
    },
    ConsumptionsCostsProductTile: {
        meta: {
            i18nDescrKey: "products-costs-and-consumptions",
            filters: [
                "farm-select-nav-bar-item",
                "campaign-select-nav-bar-item",
                "plot-selection-nav-bar-item",
                "block-selection-nav-bar-item",
            ],
            pinnable: true,
            tag: CONTEXT,
        },
        component: () => import("./components/tiles/charts/ConsumptionsCostsProductTile.vue"),
    },
    ConsumptionsCostsActivityTile: {
        meta: {
            i18nDescrKey: "activities-costs-and-consumptions",
            filters: [
                "farm-select-nav-bar-item",
                "campaign-select-nav-bar-item",
                "plot-selection-nav-bar-item",
                "block-selection-nav-bar-item",
            ],
            pinnable: true,
            tag: CONTEXT,
        },
        component: () => import("./components/tiles/charts/ConsumptionsCostsActivityTile.vue"),
    },
    ConsumptionsCostsMapTile: {
        meta: {
            i18nDescrKey: "plots-costs-and-consumptions",
            filters: [
                "farm-select-nav-bar-item",
                "campaign-select-nav-bar-item",
                "plot-selection-nav-bar-item",
                "plot-group-selection-nav-bar-item",
            ],
            pinnable: true,
            tag: CONTEXT,
        },
        component: () => import("./components/tiles/charts/consumptionsCostsMap/tile.vue"),
    },
    TotalEmissionsChartsTile: {
        meta: {
            i18nDescrKey: "total-emissions-chart",
            filters: ["farm-select-nav-bar-item", "campaign-select-nav-bar-item", "plot-selection-nav-bar-item"],
            pinnable: true,
            tag: "ESG",
        },
        component: () => import("./components/tiles/charts/totalEmissions/defaultTile.vue"),
    },
    TotalEmissionsSupplyChainChartsTile: {
        meta: {
            i18nDescrKey: "total-emissions-chart-supply-chain",
            filters: [
                "farm-select-nav-bar-item",
                "campaign-select-nav-bar-item",
                "plot-selection-nav-bar-item",
                "s-c-leader-select-nav-bar-item",
            ],
            pinnable: true,
            tag: "ESG",
        },
        component: () => import("./components/tiles/charts/totalEmissions/supplyChainTile.vue"),
    },
    PlotEmissionsChartsTile: {
        meta: {
            i18nDescrKey: "plot-emissions-chart",
            filters: ["farm-select-nav-bar-item", "campaign-select-nav-bar-item", "plot-selection-nav-bar-item"],
            pinnable: true,
            tag: "ESG",
        },
        component: () => import("./components/tiles/charts/plotEmissions/defaultTile.vue"),
    },
    PlotEmissionsSupplyChainChartsTile: {
        meta: {
            i18nDescrKey: "plot-emissions-chart-supply-chain",
            filters: [
                "farm-select-nav-bar-item",
                "campaign-select-nav-bar-item",
                "plot-selection-nav-bar-item",
                "s-c-leader-select-nav-bar-item",
            ],
            pinnable: true,
            tag: "ESG",
        },
        component: () => import("./components/tiles/charts/plotEmissions/supplyChainTile.vue"),
    },
    ActivityEmissionsChartsTile: {
        meta: {
            i18nDescrKey: "activity-emissions-chart",
            filters: ["farm-select-nav-bar-item", "campaign-select-nav-bar-item", "plot-selection-nav-bar-item"],
            pinnable: true,
            tag: "ESG",
        },
        component: () => import("./components/tiles/charts/activityEmissions/defaultTile.vue"),
    },
    ActivityEmissionsSupplyChainChartsTile: {
        meta: {
            i18nDescrKey: "activity-emissions-chart-supply-chain",
            filters: [
                "farm-select-nav-bar-item",
                "campaign-select-nav-bar-item",
                "plot-selection-nav-bar-item",
                "s-c-leader-select-nav-bar-item",
            ],
            pinnable: true,
            tag: "ESG",
        },
        component: () => import("./components/tiles/charts/activityEmissions/supplyChainTile.vue"),
    },
    CarbonFootprintMapChartTile: {
        meta: {
            i18nDescrKey: "co2-map-chart",
            filters: ["farm-select-nav-bar-item", "campaign-select-nav-bar-item", "plot-selection-nav-bar-item"],
            pinnable: true,
            tag: "ESG",
        },
        component: () => import("./components/tiles/charts/carbonFootprintMap/defaultTile.vue"),
    },
    CarbonFootprintMapSupplyChainChartTile: {
        meta: {
            i18nDescrKey: "co2-map-chart-supply-chain",
            filters: [
                "farm-select-nav-bar-item",
                "campaign-select-nav-bar-item",
                "plot-selection-nav-bar-item",
                "s-c-leader-select-nav-bar-item",
            ],
            pinnable: true,
            tag: "ESG",
        },
        component: () => import("./components/tiles/charts/carbonFootprintMap/supplyChainTile.vue"),
    },
    HistoricalEmissionsChartTile: {
        meta: {
            i18nDescrKey: "co2-historic-trend",
            filters: ["farm-select-nav-bar-item", "campaign-select-nav-bar-item", "plot-selection-nav-bar-item"],
            pinnable: true,
            tag: "ESG",
        },
        component: () => import("./components/tiles/charts/historicalEmissions/defaultTile.vue"),
    },
    HistoricalEmissionsSupplyChainChartTile: {
        meta: {
            i18nDescrKey: "co2-historic-trend-supply-chain",
            filters: [
                "farm-select-nav-bar-item",
                "campaign-select-nav-bar-item",
                "plot-selection-nav-bar-item",
                "s-c-leader-select-nav-bar-item",
            ],
            pinnable: true,
            tag: "ESG",
        },
        component: () => import("./components/tiles/charts/historicalEmissions/supplyChainTile.vue"),
    },
};

export default globals;
